import { AxiosError, AxiosInstance } from "axios";
import { ErrorDto } from "@/api-connector/play-digital-api/models/shared-models";
import { logoutService } from "@/account/services/login-services";
import { logoutUrl } from "@/api-connector/play-digital-api/metods/account/login-api";

const logoutInterceptor = (error: AxiosError<ErrorDto>) => {
    if (
        error.response.status == 401 &&
        error.response.data.code == "TOKEN_NOT_AUTHORIZED" &&
        (!error.config.url.startsWith(logoutUrl) || error.config.method != "delete")
    ) {
        logoutService(true);
    }

    return Promise.reject(error);
};

export const addLogoutInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.response.use(null, logoutInterceptor);
};
